import { createSkillsContext } from '../../contexts';
import { SkillsContextTypename } from '../../../__generated__/chirp/com/hubspot/breeze/engine/rpc/BreezeEngineStreamingService';
function deduplicateSkillRefs(refs) {
  const seen = new Set();
  return refs.filter(ref => {
    var _ref$branch;
    const key = `${ref.packageName}:${ref.skillName}:${(_ref$branch = ref.branch) !== null && _ref$branch !== void 0 ? _ref$branch : ''}`;
    if (seen.has(key)) return false;
    seen.add(key);
    return true;
  });
}
export function mergeSkillsContexts(contexts) {
  const skillsContexts = contexts.filter(ctx => ctx.__typename === SkillsContextTypename);
  if (skillsContexts.length <= 1) return contexts;
  const merged = createSkillsContext({
    additionalSkills: deduplicateSkillRefs(skillsContexts.flatMap(ctx => {
      var _ctx$additionalSkills;
      return (_ctx$additionalSkills = ctx.additionalSkills) !== null && _ctx$additionalSkills !== void 0 ? _ctx$additionalSkills : [];
    })),
    preloadedSkills: deduplicateSkillRefs(skillsContexts.flatMap(ctx => {
      var _ctx$preloadedSkills;
      return (_ctx$preloadedSkills = ctx.preloadedSkills) !== null && _ctx$preloadedSkills !== void 0 ? _ctx$preloadedSkills : [];
    })),
    excludedSkills: deduplicateSkillRefs(skillsContexts.flatMap(ctx => {
      var _ctx$excludedSkills;
      return (_ctx$excludedSkills = ctx.excludedSkills) !== null && _ctx$excludedSkills !== void 0 ? _ctx$excludedSkills : [];
    }))
  });
  return [...contexts.filter(ctx => ctx.__typename !== SkillsContextTypename), merged];
}